/* accordion-item-content.tsx generated by @compiled/babel-plugin v0.36.0 */
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { Box, xcss } from '@atlaskit/primitives';
import { breakpointValues } from '../../Breakpoints';
import { useResponsiveBreakpoint } from '../../hooks';
import { BodySmall } from '../../Typography';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _ = "._syaz1gjq{color:var(--ds-text-subtle,#44546f)}";
const accordionItemContentSpacings = xcss({
  paddingTop: 'space.100',
  paddingRight: 'space.200',
  paddingBottom: 'space.200',
  paddingLeft: 'space.600'
});
const accordionItemContentSpacingsMobile = xcss({
  paddingTop: 'space.100',
  paddingRight: 'space.200',
  paddingBottom: 'space.200',
  paddingLeft: 'space.250'
});
const accordionContentStyles = null;
export const AccordionItemContent = _ref => {
  let {
    children,
    itemKey
  } = _ref;
  const {
    value: breakPoint
  } = useResponsiveBreakpoint();
  const isMobile = breakPoint < breakpointValues.xs;
  return /*#__PURE__*/_jsx(Box, {
    xcss: isMobile ? accordionItemContentSpacingsMobile : accordionItemContentSpacings,
    role: "region",
    id: "content-".concat(itemKey),
    "aria-labelledby": "header-".concat(itemKey),
    children: /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_]
      }), /*#__PURE__*/_jsx(BodySmall, {
        className: ax(["_syaz1gjq"]),
        children: children
      })]
    })
  });
};